import UAParser from 'ua-parser-js';

import { getGlobalCountry } from '@/atoms/countryState';
import { IPlan, PeriodicityTypeEnum } from '@/utils/interfaces/Subscription';

export function calculateDays(
  periodicity: number,
  periodicityType: PeriodicityTypeEnum,
): number {
  switch (periodicityType) {
    case PeriodicityTypeEnum.daily:
      return periodicity * 1;

    case PeriodicityTypeEnum.weekly:
      return periodicity * 7;

    case PeriodicityTypeEnum.monthly:
      return periodicity * 30;

    case PeriodicityTypeEnum.yearly:
      return periodicity * 365;

    default:
      throw new Error('Invalid periodicity type');
  }
}

export function getOS(): string {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return 'server';
  }
  const parser = new UAParser();
  const result = parser.getResult();
  const osName = (result.os.name || '').toLowerCase();

  if (osName.includes('ios')) {
    return 'ios';
  }
  if (osName.includes('android')) {
    return 'android';
  }
  if (osName.includes('mac') || osName.includes('os x')) {
    if (navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
      return 'mac';
    }
    return 'mac';
  }
  if (osName.includes('win')) {
    return 'windows';
  }
  if (osName.includes('linux')) {
    return 'linux';
  }
  return 'unknown';
}

export function getBrowserVersion(): string {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return 'Server';
  }
  const parser = new UAParser();
  const result = parser.getResult();
  return result.browser.version || 'Unknown';
}

export function getBrowserName(): string {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return 'server';
  }
  const parser = new UAParser();
  const result = parser.getResult();
  return (result.browser.name || 'unknown').toLowerCase();
}

export function calculateDaysFromInterval(
  intervalCount: number,
  intervalUnit: string,
): number {
  switch (intervalUnit?.toLowerCase()) {
    case 'daily':
      return intervalCount * 1;
    case 'weekly':
      return intervalCount * 7;
    case 'monthly':
      return intervalCount * 30;
    case 'yearly':
      return intervalCount * 365;
    default:
      return 0;
  }
}

export function globalSubscriptionEvent(plan: IPlan | undefined) {
  return {
    event: {
      unit: plan?.razorpay_plan?.currency,
      value: (plan?.razorpay_plan?.amount
        ? plan?.razorpay_plan?.amount / 100
        : plan?.razorpay_plan?.amount
      )?.toString(),
    },
    meta: {
      days:
        plan?.periodicity && plan?.periodicity_type
          ? calculateDays(
              plan?.periodicity,
              plan?.periodicity_type as PeriodicityTypeEnum,
            )
          : 'Invalid periodicity type',
      currency: plan?.razorpay_plan?.currency,
      country: getGlobalCountry()?.name,
      country_code: getGlobalCountry()?.countryCode,
      platform: 'website',
      os: getOS(),
      version: getBrowserVersion(),
      browser: getBrowserName(),
    },
  };
}
